export default __webpack_public_path__ + "static/media/photo--sm--namrata-2.ebdfa51e.jpg";